export default "__VITE_ASSET__DrfHppDI__"